import { styled, component } from '../../utils/style';
import { StyleColor } from '../../utils/styles-constants';

interface PageOverlayProps {
	isOpen: boolean;
}

export const PageOverlay = styled<PageOverlayProps>()(component.div, 'PageOverlay') `
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	z-index: 11;
	background: ${StyleColor.Black};
	transition: opacity .4s cubic-bezier(.25,.8,.25,1);
	opacity: ${ props => props.isOpen ? 0.75 : 0};
	pointer-events: ${ props => props.isOpen ? 'auto' : 'none'};
`;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/PageOverlay/styles.ts